module.exports = __webpack_public_path__ + "static/img/img_background.02ec282.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/images/savethetrees/img_background.png
// module id = Zmjs
// module chunks = 0